var i18n = require('i18n')
var CustomMetaMixin = require('../mixins/custom-meta')
var tracking = require('../utils/tracking')
var redirectUrls = require('../utils/redirect-urls')

module.exports = Em.Route.extend(CustomMetaMixin, {
    activate: function() {
        this._super.apply(this, arguments)

        // Use custom title and description
        this.updateMeta('title', i18n.t('login.meta.title'))
        this.updateMeta('description', i18n.t('login.meta.description'))
    },

    beforeModel: function() {
        var self = this

        return this.handleLoginRedirect().then(function() {
            if (self.controllerFor('user').get('isAuthenticated') !== false) {
                self.replaceWith('user')
            } else {
                tracking.trackVisit('/login')
            }
        })
    },

    handleLoginRedirect: function() {
        var loginUrl = redirectUrls.getLoginRedirectUrl()

        if (loginUrl) {
            window.location.href = loginUrl
            return new Em.RSVP.Promise(function() {}) // Return pending promise to halt route
        } else {
            return Em.RSVP.resolve() // Continue with route
        }
    }
})
